export default __webpack_public_path__ + "static/media/roboto.03523cf5.ttf";